import Location from './Location'

export enum FurtherAssignment {
  CHANGE_MANAGEMENT = 'Change Management',
  CONCEPT = 'Konzept',
  DESIGN = 'Gestaltung',
  REALIZATION = 'Realisierung',
  PROJECT_MANAGEMENT = 'Projektmanagement',
}

export type Project = {
  customerUUID?: string

  uuid?: string

  name?: string
  location?: Location
  description?: string
  employeeAmount?: number
  areaInQM?: number
  furtherAssignments?: FurtherAssignment[]
  orderVolumeAnalysis?: number
  orderVolumeChangeManagement?: number
  timeSpentAnalysis?: number
  timeSpentChangeManagement?: number

  // dynamic properties
  surveyCount?: number
}
